<template>
  <div id="app">
    <h3>Vue Scroll Select</h3>
    <ScrollPicker :data="data"/>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      data: [
        { name: "16", value: "1" },
        { name: "17", value: "2" },
        { name: "18", value: "3" },
        { name: "19", value: "4" },
        { name: "20", value: "5" }
      ]
    };
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
